import React from 'react'

import { MenuItem, MenuItemProps } from '@mui/material'
import { Delete as DeleteIcon } from '@mui/icons-material'
import { useParams } from 'react-router-dom'

import { ConfirmDialog } from '@edge/spark/ui'
import { useSearchParams } from '@edge/spark/utils'

import { useDeleteDashboardCardMutation } from '@edge/spark/io-dashboards'

interface Props extends MenuItemProps {
    widgetId: string
}

export const DeleteCardMenuItem: React.FC<Props> = ({ widgetId, className, disabled, ...rest }: Props) => {
    const { uid: userId } = useSearchParams()
    const { dashId } = useParams<{ dashId?: string }>()
    const [confirmOpen, setConfirmOpen] = React.useState(false)
    const [deleteCard] = useDeleteDashboardCardMutation()

    const handleCancelConfirmDelete = () => setConfirmOpen(false)

    const handleAfirmConfirmDelete = () => {
        setConfirmOpen(false)
        return deleteCard({ variables: { userId, dashId, cardId: widgetId } })
    }

    const handleClick = () => setConfirmOpen(true)

    return (
        <>
            <ConfirmDialog
                open={confirmOpen}
                onSuccess={handleAfirmConfirmDelete}
                onFailure={handleCancelConfirmDelete}
                title="Delete"
                successButtonText="OK"
                failureButtonText="Cancel"
                icon={<DeleteIcon />}
                message="Are you sure you want to delete?"
            />
            <MenuItem {...rest} disabled={disabled} className={className} onClick={handleClick}>
                Delete
            </MenuItem>
        </>
    )
}
